import React from 'react';
import PropTypes from 'prop-types';
import { trans, withClientConfig } from '@spotahome/soyuz/client';

import SeoLandingLinks from './SeoLandingLinks';
import TypedLinks from './TypedLinks';
import { ROOM_LINK_TITLE_CONFIG, ROOM_LINK_CONFIG } from './staticLinks';

import './InternalLinking.scss';

const InternalLinkingWrapper = props => (
  <div>
    <h3 className="internal-linking__title">{props.title}</h3>
    <div className="internal-linking__links--container">{props.children}</div>
  </div>
);

InternalLinkingWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

const InternalLinking = props => {
  const { areaSlug } = props;

  return (
    <div className={`internal-linking ${props.className}`}>
      {!!(props.seoLinks && props.seoLinks.length) && (
        <InternalLinkingWrapper
          title={trans('search.others.users_search', {
            cityName: trans(`city.${areaSlug}`)
          })}
        >
          <SeoLandingLinks links={props.seoLinks} />
        </InternalLinkingWrapper>
      )}
      <InternalLinkingWrapper title={trans('search.others.property_types')}>
        <TypedLinks
          title={ROOM_LINK_TITLE_CONFIG('apartments')}
          types={ROOM_LINK_CONFIG('apartments')}
          areaSlug={areaSlug}
        />
        <TypedLinks
          title={ROOM_LINK_TITLE_CONFIG('rooms')}
          types={ROOM_LINK_CONFIG('rooms')}
          areaSlug={areaSlug}
        />
        <TypedLinks
          title={ROOM_LINK_TITLE_CONFIG('studios')}
          areaSlug={areaSlug}
        />
        <TypedLinks
          title={ROOM_LINK_TITLE_CONFIG('residences')}
          areaSlug={areaSlug}
        />
      </InternalLinkingWrapper>
    </div>
  );
};

InternalLinking.defaultProps = {
  seoLinks: [],
  className: ''
};

InternalLinking.propTypes = {
  areaSlug: PropTypes.string.isRequired,
  className: PropTypes.string,
  seoLinks: PropTypes.arrayOf(PropTypes.shape(SeoLandingLinks.propTypes)),
  clientConfig: PropTypes.shape({
    enabledCities: PropTypes.shape({
      [PropTypes.string]: PropTypes.bool
    })
  }).isRequired
};

export default withClientConfig()(InternalLinking);
